import {
  I_Paginator,
  I_PayloadGetListOrder,
} from 'app/pages/Account/ListOrder/slice/types';
import { OrderState } from 'app/pages/NewAccount/types';
import { getListOrderApi } from 'app/services/orderApi';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useListingOrderSlice } from './slice';
import { useDispatch } from 'react-redux';
import moment from 'moment';

export type SearchValueType = {
  searchText: string;
  parkId: string;
  date: string;
};

interface I_Order_List {
  holidaySubmitNumber: string;
  id: number;
  idHash: string;
  orderState: {
    value: string;
    name: string;
  };
  orderType: string;
  paymentStatus: string;
  sapSubmitNumber: string | null;
  subOrderState: string;
  thirdPartySubmitNumber: string;
  ticketChannel: string;
  totalPrice: string;
}

const useListOrder = ({
  orderState,
  isActiveTab,
  setLoading,
  onFinally,
}: {
  orderState: OrderState;
  isActiveTab: boolean;
  setLoading: (loading: boolean) => void;
  onFinally?: () => void;
}) => {
  const dispatch = useDispatch();
  const [paginator, setPaginator] = useState<I_Paginator>();
  const [listOrder, setListOrder] = useState<I_Order_List[]>();
  const isNeededCallApi = useRef(true);
  const { actions: listingOrderActions } = useListingOrderSlice();
  const [optionsGetListOrder, setOptionsGetListOrder] =
    useState<I_PayloadGetListOrder>({
      page: 1,
      limit: 20,
      search: undefined,
      orderState,
      orderDateFrom: moment().startOf('month').format('YYYY-MM-DD'),
      orderDateTo: moment().format('YYYY-MM-DD'),
    });

  const search = useCallback(
    (payload: Partial<I_PayloadGetListOrder>) => {
      isNeededCallApi.current = true;
      setOptionsGetListOrder({
        ...optionsGetListOrder,
        ...(payload as I_PayloadGetListOrder),
      });
    },
    [optionsGetListOrder],
  );

  const getListOrder = useCallback(
    async (request: I_PayloadGetListOrder) => {
      try {
        setLoading(true);
        const requestTemp = {
          ...request,
          ...(request?.orderState === 'success' && request.issueTicket
            ? { issueTicket: request.issueTicket }
            : { issueTicket: undefined }),
        };
        const { data } = await getListOrderApi(requestTemp);
        //call get Count tại đây khi có api, mỗi lần getList sẽ getCount luôn
        // console.log("data",data)
        dispatch(
          listingOrderActions.setOrderCount({
            success: data?.orderCount?.success || 0,
            paymentPending: data?.orderCount?.paymentPending || 0,
            cancel: data?.orderCount?.cancelled || 0,
          }),
        );
        setListOrder(data.data);
        setPaginator(data.paginator);
      } catch (error) {
      } finally {
        setLoading(false);
        onFinally?.();
      }
    },
    [setLoading, onFinally],
  );

  const getListOrderOnCancelOrderSuccess = useCallback(() => {
    isNeededCallApi.current = true;
    if (+(paginator?.currentItemCount ?? 0) <= 1) {
      setOptionsGetListOrder(prev => ({
        ...prev,
        page: prev.page > 1 ? prev.page - 1 : 1,
      }));
    } else {
      setOptionsGetListOrder(prev => ({
        ...prev,
      }));
    }
  }, [paginator?.currentItemCount]);

  useEffect(() => {
    if (isActiveTab && isNeededCallApi.current) {
      getListOrder({ ...optionsGetListOrder });
      isNeededCallApi.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsGetListOrder, isActiveTab]);

  return {
    listOrder: listOrder,
    paginator,
    search,
    getListOrderOnCancelOrderSuccess,
    optionsGetListOrder,
  };
};

export default useListOrder;
